import { useEffect, useRef, useState } from "react";
import style from "./Select.module.scss";
import cn from "classnames";

export interface ValueSelect {
  value: string;
  label: string;
}

export function Select({
  listValues,
  currentValue,
  onChange,
  customStyle,
  listAlign = "bottom"
}: {
  listValues: ValueSelect[];
  currentValue: ValueSelect;
  onChange: (value: ValueSelect) => void;
  customStyle?: {
    currentValue?: React.HTMLAttributes<HTMLElement>["className"];
    listValues?: React.HTMLAttributes<HTMLElement>["className"];
    value?: React.HTMLAttributes<HTMLElement>["className"];
  };
  listAlign?: "top" | "bottom"
}) {
  const refContainer = useRef<HTMLDivElement | null>(null);
  
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    function handleClick(e: any) {
      if (!refContainer.current?.contains(e.target)) {
        setIsOpen(false);
      }
    }

    document.documentElement.addEventListener("click", handleClick);

    return () => {
      document.documentElement.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div ref={refContainer} className={cn(style.container, isOpen && style.open)}>
      <div
        className={cn(style.currentValue, customStyle?.currentValue)}
        onClick={() => {
          setIsOpen((state) => !state);
        }}
      >
        <p>{currentValue.label}</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
        >
          <path
            d="M5.50503 9.99497C5.77839 10.2683 6.22161 10.2683 6.49497 9.99497L10.9497 5.5402C11.2231 5.26683 11.2231 4.82362 10.9497 4.55025C10.6764 4.27689 10.2332 4.27689 9.9598 4.55025L6 8.51005L2.0402 4.55025C1.76684 4.27689 1.32362 4.27689 1.05025 4.55025C0.776885 4.82362 0.776885 5.26684 1.05025 5.5402L5.50503 9.99497ZM5.3 8.5L5.3 9.5L6.7 9.5L6.7 8.5L5.3 8.5Z"
            fill="#676D83"
          />
        </svg>
      </div>
      <div className={cn(style.listValues, customStyle?.listValues, style["align_" + listAlign])}>
        {listValues.map(({ value, label }) => (
          <div
            key={value}
            className={cn(
              style.value,
              value === currentValue.value && style.value_active,
              customStyle?.value,
            )}
            onClick={() => {
              if (value !== currentValue.value) {
                onChange({ value, label });
              }
              setIsOpen(false);
            }}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
